module.exports = __webpack_public_path__ + "images/product-navigation/devices-b09cf74b.svg";